import { render, staticRenderFns } from "./IconArrowCircularLinear.vue?vue&type=template&id=b61ac160&scoped=true"
import script from "./IconArrowCircularLinear.vue?vue&type=script&lang=js"
export * from "./IconArrowCircularLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ac160",
  null
  
)

export default component.exports